import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./Depositemireciept.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

const Depositemireciept = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { account, emi ,nextemi} = location.state ;
  console.log("emi is ",emi);

  const receiptRef = useRef(null);
  const thermalReceiptRef = useRef(null);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  const [company, setCompany] = useState(null);

  // Fetch profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch company info
  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
        }
        if (data.qrCodeImage) {
          data.qrCodeUrl = `https://narrowitsolution.in/${data.qrCodeImage.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error("Error fetching company:", err);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchCompany();
    }
  }, [profile?.superAdminId]);

  const handlePrint = async () => {
    if (!receiptRef.current) return;

    const pdf = new jsPDF("p", "mm", "a4");

    const canvas = await html2canvas(receiptRef.current, {
      scale: 1.5,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.9);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);

    const blobUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      window.addEventListener(
        "focus",
        () => {
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 500);
        },
        { once: true }
      );
    };
  };

  const handlePrintThermalSlip = async () => {
    if (!thermalReceiptRef.current) return;

    try {
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;

      doc.open();
      doc.write(`
        <html>
          <head>
            <style>
              @page {
                size: 58mm auto;
                margin: 0;
              }
              body {
                margin: 0;
                padding: 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
              }
              img {
                width: 58mm;
                max-width: 58mm;
                margin: 0 auto;
                display: block;
              }
            </style>
          </head>
          <body></body>
        </html>
      `);
      doc.close();

      const canvas = await html2canvas(thermalReceiptRef.current, {
        scale: 3,
        backgroundColor: "#fff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const img = doc.createElement("img");
      img.src = imgData;

      await new Promise((res) => (img.onload = res));
      doc.body.appendChild(img);

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 300);
    } catch (err) {
      console.error("Thermal printing failed", err);
      alert("Thermal print failed");
    }
  };

  // if (!account || !emi) {
  //   return <div className="p-10 text-center">Receipt Data Not Found</div>;
  // }

  return (
    <div className="receipt-viewer-container">
      {/* Action Buttons */}
      <div className="receipt-actions receipt-no-print">
        <button onClick={() => navigate(-1)} className="receipt-back-btn">
          Back
        </button>
        <button onClick={handlePrint} className="btn-print-receipt">
          Print Receipt
        </button>
        <button
          onClick={handlePrintThermalSlip}
          className="btn-thermal-print-receipt"
        >
          Thermal Print Receipt
        </button>
      </div>

      {/* Printable Receipt Design */}
      <div
        id="receipt-0"
        style={{ pageBreakAfter: "always" }}
        className="receipt-paper"
        ref={receiptRef}
      >
        <div className="receipt-header-section">
          <div className="receipt-header-company-section">
            <div className="receipt-company-details">
              <img
                src={company?.logoUrl}
                alt="logo"
                className="receipt-logo"
              />
              <div className="receipt-header-company-info">
                <h1>{company?.name || "N/A"}</h1>
                <p className="address">
                  <b>Address: </b>
                  {company?.address || "N/A"}
                </p>
                <p className="contact">
                  <b>Phone:</b> {company?.contact || "N/A"}  
                </p>
                <p className="contact">
                  <b>Email:</b>{" "}{company?.email || "N/A"}
                </p>
                <p className="cin">
                  <b>CIN:</b> {company?.cin || "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="receipt-title-box">
            <h2>COLLECTION RECEIPT</h2>
            <p>
              Receipt No: #{emi?.id || "905"} | Date:{" "}
              {new Date(emi?.paymentDate || Date.now()).toLocaleDateString("en-In")}
            </p>
          </div>
        </div>

        {/* Sections */}
        <div className="receipt-section">
          <h3 className="receipt-section-title">EMI Collection DETAILS</h3>
          <div className="receipt-details-wrapper">
            <div className="receipt-grid-item">
              <span>Customer Name:</span>{" "}
              <strong>{account?.customerName || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Loan Account Number:</span>{" "}
              <strong>{account?.accountNo || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Emi Number:</span>{" "}
              <strong>{emi?.installmentNo  || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Emi Amount:</span>{" "}
              <strong>{"₹" + (emi?.amount?.toLocaleString() || "N/A")}</strong>
            </div>
            {/* <div className="receipt-grid-item">
              <span>Principal Amount:</span>{" "}
              <strong>{"₹" + (emi?.principalComponent || "N/A")}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Interest Rate:</span>{" "}
              <strong>{"₹" + (emi?.interestComponent || "N/A")}</strong>
            </div> */}
            <div className="receipt-grid-item ">
              <span>Due Date:</span>{" "}
              <strong>
                {emi?.dueDate
                  ? new Date(emi.dueDate).toLocaleDateString("en-In")
                  : "N/A"}
              </strong>
            </div>
            <div className="receipt-grid-item due-date-special">
              <span>Next Due Date:</span>{" "}
              <strong>
                {nextemi?.dueDate
                  ? new Date(nextemi.dueDate).toLocaleDateString("en-In")
                  : "N/A"}
              </strong>
            </div>
            <div className="receipt-grid-item">
              <span>Paid Date:</span>{" "}
              <strong>
                {emi.collectionDate
                  ? new Date(emi.collectionDate).toLocaleDateString("en-In")
                  : "N/A"}
              </strong>
            </div>
            <div className="receipt-grid-item">
              <span>Status:</span>{" "}
              <strong>{emi?.status?.toUpperCase() || "N/A"}</strong>
            </div>
          </div>
        </div>

        {/* <table className="receipt-outstanding-table">
          <tbody>
            <tr className="receipt-outstanding-row">
              <td>Outstanding Amount</td>
              <td>
                ₹{" "}
                {Number(emi?.outstanding || 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </td>
            </tr>
          </tbody>
        </table> */}

        <div className="receipt-footer-signs">
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Authorized Signatory</p>
          </div>
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Customer Signature</p>
          </div>
        </div>

        <p className="receipt-system-gen-text">
          This is a system-generated slip and does not require a signature.
          <br />
          For any queries, please contact us during business hours.
        </p>
      </div>

      {/* Thermal print design */}
      <div id="thermal-0" className="thermal-slip-wrapper">
        <div ref={thermalReceiptRef} className="thermal-slip">
          {/* COMPANY INFO */}
          <div className="thermal-company">
            <div className="thermal-company-name">
              {company ? company.name : "--"}
            </div>
            <div className="thermal-company-text">
              <b>Address:</b> {company ? company.address : "--"}
            </div>
            <div className="thermal-company-text">
              <b>Phone:</b> {company ? company.contact : "--"} | <b>Email:</b>{" "}
              {company ? company.email : "--"}
            </div>
            <div className="thermal-company-text">
              <b>CIN:</b> {company ? company.cin : "--"}
            </div>
          </div>

          {/* TITLE */}
          <div className="thermal-title">EMI Collection Receipt</div>

          <div className="thermal-divider"></div>

          {/* DETAILS */}
          <div className="thermal-row">
            <b>Customer Name:</b> {account?.customerName || "--"}
          </div>
          <div className="thermal-row">
            <b>Account Number:</b> {account?.accountNo || "--"}
          </div>
          <div className="thermal-row">
            <b>EMI Number:</b> {emi?.installmentNo || "--"}
          </div>
          <div className="thermal-row">
            <b>EMI Amount:</b> {"₹" + (emi?.amount || "--")}
          </div>
          <div className="thermal-row">
            <b>Due Date :</b>{" "}
            {emi?.dueDate
              ? new Date(emi.dueDate).toLocaleDateString("en-In")
              : "--"}
          </div>
          <div className="thermal-row">
            <b>Next Due Date :</b>{" "}
            {nextemi?.dueDate
              ? new Date(nextemi.dueDate).toLocaleDateString("en-In")
              : "--"}
          </div>
          <div className="thermal-row">
            <b>Paid Date:</b>{" "}
            {emi?.collectionDate
              ? new Date(emi.collectionDate).toLocaleDateString("en-In")
              : "--"}
          </div>
          <div className="thermal-row">
            <b>Status:</b> {emi?.status || "--"}
          </div>
          {/* <div className="thermal-row">
            <b>Outstanding Amount:</b> ₹ {emi?.outstanding || "--"}
          </div> */}

          <div className="thermal-divider"></div>

          {/* FOOTER */}
          <div className="thermal-footer">
            <div>Thank you for your payment!</div>
            <div>Computer Generated Receipt</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Depositemireciept;
